import styled from 'styled-components/macro';

const LoanHeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export default LoanHeaderContent;
